<template>
  <div hight="100%">
    <v-simple-table dense>
      <thead>
        <tr>
          <th style="font-size: 14px">
            <div v-if="isRegis">วันทำการ</div>
            <div v-else>วันจัดเก็บ</div>
          </th>
          <th style="font-size: 14px">วัน</th>
          <th style="font-size: 14px">
            <div v-if="isRegis">เวลาเปิด</div>
            <div v-else>เวลาเปิด - ปิด</div>
          </th>
          <th style="font-size: 14px">
            <div v-if="isRegis">เวลาปิด</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in list_days"
          :key="index"
          :style="
            item.ISOPEN && !item.TRANSPORT
              ? 'background-color:#FFF8E1'
              : item.ISOPEN || item.TRANSPORT
              ? 'background-color:#DCEDC8'
              : ''
          "
        >
          <td class="text-center">
            <v-checkbox
              color="info"
              v-if="isRegis"
              v-model="item.ISOPEN"
              @change="(event) => checkOpen(index, event)"
            ></v-checkbox>
            <v-checkbox
              color="info"
              v-else
              v-model="item.TRANSPORT"
              @change="(event) => checkTranSport(index, event)"
            ></v-checkbox>
          </td>
          <td>{{ item.DAYS }}</td>
          <td>
            <vue-timepicker
              v-model="item.HOURS_START"
              auto-scroll
              drop-direction="auto" :drop-offset-height="800"
              v-if="isRegis"
              close-on-complete
              format="HH:mm"
              :disabled="!item.ISOPEN"
            ></vue-timepicker>
            <div v-else>
              {{ item.HOURS_START | elimateHour }} -
              {{ item.HOURS_END | elimateHour }}
            </div>
          </td>
          <td>
            <vue-timepicker
              v-model="item.HOURS_END"
              v-if="isRegis"
              auto-scroll
              drop-direction="auto" :drop-offset-height="800"
              close-on-complete
              format="HH:mm"
              :disabled="!item.ISOPEN"
            ></vue-timepicker>
            <!-- <vue-timepicker
              v-model="item.TRANSPORT_TIME"
              v-else
              auto-scroll
              close-on-complete
              format="HH:mm"
              :disabled="!item.TRANSPORT"
            ></vue-timepicker> -->
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: "Day",
  props: {
    fromPage: String,
    zoneData: Array,
  },
  components: {
    VueTimepicker,
  },
  data() {
    return {
      // list_days:[]
    };
  },
  computed: {

    ...mapGetters({
      myState: 'CustomerDetail/GET_DAYS',
      cusData: 'CustomerDetail/GET_CUSTOMER',
    }),
    list_days() {
     
      return this.myState
    }
  },
  filters: {
    elimateHour(i) { 
      return i == 'HH:mm' || i == null ? '' : i.split(':')[0] + ':' + i.split(':')[1] + ' น.'
    }
  },
  watch: {

  },
  mounted() {
    if (this.fromPage == 'regsiter_cus') {
      this.$store.dispatch('CustomerDetail/initDays')
    }

  },
  created() {

    if (this.fromPage == 'regsiter_cus') {
      this.isRegis = true
    } else {
      this.isRegis = false
    }
    //console.log(this.myState)

  },
  methods: {
    ...mapMutations({
      SET_EL_CUS: 'CustomerDetail/SET_ELEMENT',
    }),
    checkOpen(i, e) {
      if (!e) {
        this.$store.dispatch('CustomerDetail/resetHour', i)
      }
    },
    checkTranSport(i, e) {
      if (!e) {
        this.$store.dispatch('CustomerDetail/resetTranHour', i)
      }
      const zData = this.zoneData
      const cData = this.cusData
      let arr_day = this.myState
      var fil_day = arr_day.filter(function (el) {
        return el.TRANSPORT
      }).map(key => { return key.DAYS });
      // var regex = new RegExp(fil_day.toString(), 'i');
      var fil_zData = zData.filter(function (el) {
        let a_day = el.DAYS.split(',')
        let a_province = el.A_PROVINCE ? el.A_PROVINCE.split(',') : []
        let a_area = el.AREA ? el.AREA.split(',') : []
        let final_day = fil_day.every(v => a_day.includes(v))
        let final_pro = a_province.includes(cData.CUSTOMER_PROVINCE)
        let final_area = a_area.includes(cData.CUSTOMER_DISTRICT)

        return final_day && final_pro && final_area
      })
      if(fil_zData.length > 0){
        this.SET_EL_CUS({ key: "COLLECT_ZONE", value: fil_zData[0].Z_NAME })
      }
      
    }
  },
};
</script>